const standard = [{
  featureType: "poi.place_of_worship",
  stylers: [{
    visibility: "off"
  }]
}, {
  featureType: "poi",
  elementType: "labels.icon",
  stylers: [{
    visibility: "off"
  }]
}];
export default standard;